<template>
  <div id="VditorPreview" ref="preview"></div>
</template>

<script>
import { sanitizeHtml } from "@/utils/sanitizeHtml";

export default {
  name: "MarkdownPreview",
  props: {
    value: {
      type: String,
      default: "",
    },
    // 预览后的回调
    after: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      contentPreview: "",
    };
  },
  mounted() {
    this.renderPreview(this.value);
  },
  watch: {
    value(newVal) {
      // 监测切换多语言调用渲染
      this.renderPreview(newVal);
    },
  },
  methods: {
    renderPreview(content) {
      const dom = this.$refs.preview;
      if (!dom) return;
      Vditor.preview(dom, content || "", {
        cdn: "/vditor",
        // 关闭代码块/公式二次渲染分支，降低 echarts/mermaid 等注入面
        markdown: {
          sanitize: true,
          codeBlockPreview: false,
          mathBlockPreview: false,
        },
        // Lute 输出写入 innerHTML 前做白名单净化，封堵 sanitize 黑名单绕过
        transform: (html) => sanitizeHtml(html),
        after: () => {
          this.after();
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.markdown-preview ::v-deep {
  ul {
    list-style: disc;
  }
  ol {
    list-style: decimal;
  }
  li {
    list-style: inherit;
  }
  a,
  a:focus,
  a:hover {
    color: #4285f4;
    text-decoration: underline;
  }
}
// 表格内容换行展示
.vditor-reset ::v-deep table td,
th {
  word-break: break-all;
  word-wrap: break-word;
  white-space: pre-wrap;
}
</style>
